import toast from 'react-hot-toast';
import { Info, X } from 'lucide-react';
import { RETRIEVAL_COMPLETE_TOAST_OPTIONS, RETRIEVAL_COMPLETE_TOAST_STYLE } from './retrievalToasts';

function RetrievalCompleteToastContent({ toastId, message }: { toastId: string; message: string }) {
  return (
    <div
      style={{
        ...RETRIEVAL_COMPLETE_TOAST_STYLE,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <Info className="h-5 w-5 shrink-0" style={{ color: 'inherit' }} />
      <span style={{ flex: 1, minWidth: 0 }}>
        {message}
      </span>
      <button
        type="button"
        onClick={() => toast.dismiss(toastId)}
        aria-label="Dismiss"
        className="opacity-80 hover:opacity-100 transition-opacity"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 4,
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          borderRadius: 4,
        }}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

export function showRetrievalCompleteToast(message: string) {
  toast.custom(
    (t) => <RetrievalCompleteToastContent toastId={t.id} message={message} />,
    RETRIEVAL_COMPLETE_TOAST_OPTIONS
  );
}
